export default "__VITE_ASSET__7bae3032__"